import { render, staticRenderFns } from "./creatsuccess.vue?vue&type=template&id=44babaf7&scoped=true"
import script from "./creatsuccess.vue?vue&type=script&lang=js"
export * from "./creatsuccess.vue?vue&type=script&lang=js"
import style0 from "./creatsuccess.vue?vue&type=style&index=0&id=44babaf7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44babaf7",
  null
  
)

export default component.exports